export function useOldParagraphState() {
  const routeParams = useRouteParams<{
    oldParagraphId?: string;
  }>();
  const mounted = useMounted();
  const activeOldParagraphId = computed(() =>
    mounted.value && routeParams.oldParagraphId
      ? Number(routeParams.oldParagraphId)
      : undefined
  );
  const {
    query: { data: oldParagraph, isLoading: oldParagraphLoading },
  } = useFetchParagraphById(activeOldParagraphId);

  return {
    oldParagraph,
    oldParagraphLoading,
  };
}
